import {
    SEARCH_REFERRALS,
    SEARCH_REFERRALS_SUCCESS,
    SEARCH_REFERRALS_FAILURE,
    REFRESH_REFERRAL_STATUS,
    REFRESH_REFERRAL_STATUS_SUCCESS,
    REFRESH_REFERRAL_STATUS_FAILURE,
    LIST_REFERRALS,
    LIST_REFERRALS_SUCCESS,
    LIST_REFERRALS_FAILURE,
    FETCH_REFERRAL_DETAILS,
    FETCH_REFERRAL_DETAILS_SUCCESS,
    FETCH_REFERRAL_DETAILS_FAILURE,
    CLOSE_DIALOGS,
    FETCH_REFERRAL_CONTENT,
    FETCH_REFERRAL_CONTENT_SUCCESS,
    FETCH_REFERRAL_CONTENT_FAILURE,
    OPEN_REFERRAL_DETAILS_DIALOG
} from './ReferralListActionTypes'

export const initialReferralListState = () => ({
    referrals: null,
    errorMessage: null,
    isLoading: false,
    referralDetails: null,
    detailsLoading: false,
    detailsError: null,
    selectedReferralId: null,
    referralContent: null,
    contentLoading: false,
    contentError: null,
    detailsDialogOpen: false,
    currentPage: 0,
    totalPages: 0,
    totalElements: 0,
});

const referralList = (state = initialReferralListState(), action) => {
    switch (action.type) {
        case SEARCH_REFERRALS:
            return {
                ...state,
                // isLoading: true,
                errorMessage: null,
            }
        case SEARCH_REFERRALS_SUCCESS:
            return {
                ...state,
                referrals: action.referrals,
                errorMessage: null,
                // isLoading: false,
            }
        case SEARCH_REFERRALS_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                // isLoading: false,
            }
        case REFRESH_REFERRAL_STATUS:
            return {
                ...state,
                // isLoading: true,
            }
        case REFRESH_REFERRAL_STATUS_SUCCESS:
            return {
                ...state,
                referrals: state.referrals.map(r =>
                    r.referralId === action.referral.referralId ? action.referral : r
                ),
                errorMessage: null,
                // isLoading: false,
            }
        case REFRESH_REFERRAL_STATUS_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                // isLoading: false,
            }
        case LIST_REFERRALS:
            return {
                ...state,
                // isLoading: true,
                errorMessage: null,
            }
        case LIST_REFERRALS_SUCCESS:
            return {
                ...state,
                referrals: action.referrals.content,
                currentPage: action.referrals.number,
                totalPages: action.referrals.totalPages,
                totalElements: action.referrals.totalElements,
                errorMessage: null,
                // isLoading: false,
            }
        case LIST_REFERRALS_FAILURE:
            return {
                ...state,
                errorMessage: action.errorMessage,
                // isLoading: false,
            }
        case FETCH_REFERRAL_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                detailsError: null,
            }
        case FETCH_REFERRAL_DETAILS_SUCCESS:
            return {
                ...state,
                referralDetails: action.details,
                detailsLoading: false,
                detailsError: null,
            }
        case FETCH_REFERRAL_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
                detailsError: action.errorMessage,
            }
        case CLOSE_DIALOGS:
            return {
                ...state,
                detailsDialogOpen: false,
                selectedReferralId: null,
                referralDetails: null,
                detailsError: null,
                referralContent: null,
                contentError: null,
            }
        case FETCH_REFERRAL_CONTENT:
            return {
                ...state,
                contentLoading: true,
                contentError: null,
            }
        case FETCH_REFERRAL_CONTENT_SUCCESS:
            return {
                ...state,
                referralContent: action.content,
                contentLoading: false,
                contentError: null,
            }
        case FETCH_REFERRAL_CONTENT_FAILURE:
            return {
                ...state,
                contentLoading: false,
                contentError: action.errorMessage,
            }
        case OPEN_REFERRAL_DETAILS_DIALOG:
            return {
                ...state,
                detailsDialogOpen: true,
                selectedReferralId: action.referralId,
                referralContent: null,
                contentError: null,
                referralDetails: null,
                detailsError: null,
            }
        default:
            return state;
    }
}

export default referralList;